export const projectsList = [
  {
    id: 0,
    title: "STAATSLIEDEN",
    screenshot: "/images/staatslieden.png",
    icons: "/images/alliconsnextjs.png",
    languages: [
      "Nextjs 15",
      "Tailwind",
      "NextAuth (OAuth 2.0)",
      "Next-intl(i18n)",
      "SWR",
      "Cloudinary",
      "MongoDB",
    ],
    mockups: "/mockups/staatsliedenResp.png",
    screens: [
      { screenBig: "/screens/sl_home.png" },
      { screenBig: "/screens/sl_weer.png" },
      { screenBig: "/screens/sl_demografie.png" },
      { screenBig: "/screens/sl_iPad.png" },
      { screenBig: "/screens/sl_iPad_2.png" },
      { screenBig: "/screens/sl_iPad_3.png" },
      { screenBig: "/screens/sl_iPhones.png" },
      { screenBig: "/screens/sl_macbook.png" },
      { screenBig: "/screens/sl_iPhones_2.png" },
    ],
    github: "https://github.com/Noud63/staatslieden",
    github2: "https://www.staatsliedenbuurtamsterdam.nl/",
    description: `STAATSLIEDEN is a NEXT.js 14 app router application.<br /><br />`,
  },
  {
    id: 1,
    title: "REAL ESTATE AGENT",
    screenshot: "/images/elliecastelli.png",
    icons: "/images/alliconssass_big.png",
    languages: [
      "HTML5",
      "Sass",
      "Javascript",
      "React Redux-Toolkit",
      "REST-api",
      "MongoDB",
    ],
    mockups: "/mockups/ellieResp.png",
    screens: [
      { screenBig: "/screens/elliecastelliBig.png" },
      { screenBig: "/screens/elliecastelli1Big.png" },
      { screenBig: "/screens/elliecastelli2Big.png" },
      { screenBig: "/screens/elliecastelli3Big.png" },
      { screenBig: "/screens/elliecastelli4Big.png" },
      { screenBig: "/screens/elliecastelli5Big.png" },
      { screenBig: "/screens/elliecastelli6Big.png" },
      { screenBig: "/screens/elliecastelli7Big.png" },
      { screenBig: "/screens/elliecastelli8Big.png" },
    ],
    github: "https://github.com/Noud63/real-estate-agent",
    github2: "https://real-estate-agent.onrender.com/",
    description: ` Real Estate Agent Ellie Castelli is a MERN Stack application.<br /><br />
                      Front-end: React, Redux-Toolkit,  Sass<br />
                      Back-end: Express, Node, MongoDB<br/><br />
                      It is an E-Commerce Web App where you can buy luxury real estate in France.<br />
                      I used React, Redux-Toolkit and Sass for the frontend part of the app, and for the back-end I used 
                      MongoDB, Express and Node.<br />
                      There is a search function where you can filter data from an api request based on certain criteria.<br />
                      With each item in the list of real-estate objects you can write an enquiry email for more information.<br />
                      You can subscribe to a newsletter and magazine.<br />
                      To subscribe to the newsletter and magazine a user can choose a payment method provided by Stripe.js. It is an integraded payment procedure so no redirect to stripe.<br />
                      A user can register and login. JSON Web Token is used for authentication and authorization.<br />
                      A user can update his profile when logged in.<br />
                      The owner can login as an administrator and perform exclusive tasks like delete a registered user or upload a new estate (document) to the database.<br />
                      All registered users are stored in a mongoDB database aswell as the data (real-estate-properties) that are loaded by default, and all the email addresses of newsletter subscribers.<br />
                      The application is responsive.<br />
                      (NOTE! Deployed to Render at https://real-estate-agent.onrender.com , takes a while to load +/- 30sec. )`,
  },
  {
    id: 2,
    title: "RENT YOUR DREAM",
    screenshot: "/images/ec_rental.png",
    icons: "/images/alliconsnextjs.png",
    languages: [
      "HTML5",
      "Tailwind",
      "Nextjs",
      "NextAuth.js",
      "OAuth 2.0",
      "MongoDB",
    ],
    mockups: "/mockups/ecrentalResp.png",
    screens: [
      { screenBig: "/screens/ec_rental_1.png" },
      { screenBig: "/screens/ec_rental_2.png" },
      { screenBig: "/screens/ec_rental_3.png" },
      { screenBig: "/screens/ec_rental_4.png" },
      { screenBig: "/screens/ec_rental_5.png" },
      { screenBig: "/screens/ec_rental_7.png" },
    ],
    github: "https://github.com/Noud63/Register-form",
    github2: "https://elliecastelli-rental.vercel.app/",
    description: `Platform where real-estate owners can list their properties for rent.<br /><br />
                  Build with:<br /> 
                  Next.js 14, NextAuth.js, OAuth 2.0, MongoDB, Resend, Tailwind, Shadcn/ui, Cloudinary, opencage-api-client (geocoding), Leaflet OpenStreetMap<br />
                  Features:<br />
                  register<br />
                  login with:<br />
                  - credentials<br />
                  - email (magic link)<br />
                  - google<br />
                  - facebook<br />
                  Reset password<br />
                  Upload property (attached image files uploaded to Cloudinary)<br />
                  Edit or delete uploaded property<br />
                  Edit user profile (+ upload new avatar to cloudinary)<br />
                  Search property<br />
                  Share property on social media<br />
                  Send message to property owner<br />
                  List messages<br />
                  View listed properties as owner<br />
                  Bookmark property<br />
                  View Bookmarked properties<br />
                  SignOut`,
  },
  {
    id: 3,
    title: "ART IN AMSTERDAM",
    screenshot: "/images/artinamsterdam.png",
    icons: "/images/alliconsnextjs.png",
    languages: [
      "Nextjs 16",
      "Tailwind",
      "NextAuth",
      "OAuth 2.0",
      "Leaflet Map",
      "MongoDB"
    ],
    mockups: "/mockups/artinamsterdamResp.png",
    screens: [
      { screenBig: "/screens/artinamsterdamBig.png" },
      { screenBig: "/screens/artinamsterdam1Big.png" },
      { screenBig: "/screens/artinamsterdam2Big.png" },
      { screenBig: "/screens/artinamsterdam_iPhones.png" },
      { screenBig: "/screens/artinamsterdam_macbook_1.png" },
      { screenBig: "/screens/artinamsterdam_macbook_2.png" },
    ],
    github: "https://github.com/Noud63/artinamsterdam_nextjs",
    github2: "https://artinamsterdam-nextjs.vercel.app/",
    description: "Art in Amsterdam is a Nextjs 16 application. It is an interactive map highlights 80 art-locations across Amsterdam, including art galleries, museums, art centres, and public artworks.",
  },
  {
    id: 4,
    title: "DUTCH FOOTBALL LEAGUE",
    screenshot: "/images/eredivisie.png",
    icons: "/images/basicreactresticons.png",
    languages: ["HTML5", "CSS3", "Javascript", "React", "REST-api", "MongoDB"],
    mockups: "/mockups/eredivisieResp.png",
    screens: [
      { screenBig: "/screens/eredivisieBig.png" },
      { screenBig: "/screens/eredivisie1Big.png" },
      { screenBig: "/screens/eredivisie2Big.png" },
      { screenBig: "/screens/eredivisieMobileBig.png" },
      { screenBig: "/screens/eredivisieMobile2Big.png" },
      { screenBig: "/screens/eredivisieMacBookBig.png" },
    ],
    github: "https://github.com/Noud63/eredivisie",
    github2: "https://eredivisie-frontend.vercel.app/",
    description: "Dutch Football League App build with React and Football Api(https://api.football-data.org).",
  },
  {
    id: 5,
    title: "BE SMART BUY ART",
    screenshot: "/images/artshop.png",
    icons: "/images/allicons.png",
    languages: ["HTML5", "CSS3", "Javascript", "React", "REST-api"],
    mockups: "/mockups/bsbaResp.png",
    screens: [
      { screenBig: "/screens/bsbaBig.png" },
      { screenBig: "/screens/bsba1Big.png" },
      { screenBig: "/screens/bsba2Big.png" },
      { screenBig: "/screens/bsba3Big.png" },
      { screenBig: "/screens/bsba4Big.png" },
      { screenBig: "/screens/bsba5Big.png" },
    ],
    github: "https://github.com/Noud63/besmartbuyart-react",
    github2: "",
    description: "Be Smart Buy Art is an art webshop with the basic features of an e-commerce webshop.",
  },
  {
    id: 6,
    title: "BLOG",
    screenshot: "/images/blog.png",
    icons: "/images/allicons.png",
    languages: [
      "HTML5",
      "CSS3",
      "Javascript",
      "React Redux-Toolkit",
      "REST-api",
      "MongoDB",
    ],
    mockups: "/mockups/blogResp.png",
    screens: [
      { screenBig: "/screens/blogBig.png" },
      { screenBig: "/screens/blog1Big.png" },
      { screenBig: "/screens/blog2Big.png" },
      { screenBig: "/screens/blog3Big.png" },
      { screenBig: "/screens/blog4Big.png" },
      { screenBig: "/screens/blog5Big.png" },
    ],
    github: "https://github.com/Noud63/react-redux-toolkit-blog",
    github2: "",
    description: "React Redux Toolkit Blog.",
  },
  {
    id: 7,
    title: "COUNTRIES OF EUROPE",
    screenshot: "/images/europa.png",
    icons: "/images/allicons.png",
    languages: ["HTML5", "CSS3", "Javascript", "React", "REST-api", "MongoDB"],
    mockups: "/mockups/europeResp.png",
    screens: [
      { screenBig: "/screens/europeBig.png" },
      { screenBig: "/screens/europe1Big.png" },
      { screenBig: "/screens/europe2Big.png" },
    ],
    github: "https://github.com/Noud63/countriesineurope",
    github2: "https://noud63.github.io/europe/",
    description: "Countries of Europe introduces you to all the countries in Europe.",
  },
  {
    id: 8,
    title: "DASHBOARD",
    screenshot: "/images/dashboard.png",
    icons: "/images/alliconsmui.png",
    languages: [
      "HTML5",
      "MaterialUI",
      "React",
      "React Redux-Toolkit",
      "REST-api",
      "MongoDB",
    ],
    mockups: "/mockups/dashboardResp.png",
    screens: [
      { screenBig: "/screens/dashboardBig.png" },
      { screenBig: "/screens/dashboard1Big.png" },
      { screenBig: "/screens/dashboard2Big.png" },
      { screenBig: "/screens/dashboard3Big.png" },
      { screenBig: "/screens/dashboard4Big.png" },
      { screenBig: "/screens/dashboard5Big.png" },
    ],
    github: "https://github.com/Noud63/dashboard",
    github2: "",
    description: `Dashboard is a MERN Stack application.`,
  },
  {
    id: 9,
    title: "SEARCH RECIPES",
    screenshot: "/images/food.png",
    icons: "/images/basicresticons.png",
    languages: ["HTML5", "CSS3", "Javascript", "REST-api"],
    mockups: "/mockups/forkifyResp.png",
    screens: [
      { screenBig: "/screens/foodapiBig.png" },
      { screenBig: "/screens/foodapi2Big.png" },
      { screenBig: "/screens/foodapi3Big.png" },
    ],
    github: "https://github.com/Noud63/forkify",
    github2: "https://what-do-we-eat2.netlify.app/",
    description: "Recipe Search Desktop App build with javascript ES6 modules.",
  },
  {
    id: 10,
    title: "QUIZ",
    screenshot: "/images/quiz.png",
    icons: "/images/basicicons.png",
    languages: ["HTML5", "CSS3", "Javascript"],
    mockups: "/mockups/quizResp.png",
    screens: [
      { screenBig: "/screens/quizBig.png" },
      { screenBig: "/screens/quiz1Big.png" },
      { screenBig: "/screens/quiz2Big.png" },
    ],
    github: "https://github.com/Noud63/Quiz",
    github2: "https://noud63.github.io/Quiz/",
    description: `Vanilla Javascript Quiz App`,
  },
  {
    id: 11,
    title: "TAKE A BREAK",
    screenshot: "/images/relax.png",
    icons: "/images/basicicons.png",
    languages: ["HTML5", "CSS3", "Javascript"],
    mockups: "/mockups/takeabreakResp.png",
    screens: [
      { screenBig: "/screens/relaxeBig.png" },
      { screenBig: "/screens/relaxe2Big.png" },
      { screenBig: "/screens/relaxe1Big.png" },
    ],
    github: "https://github.com/Noud63/Relax",
    github2: "https://noud63.github.io/Relax/",
    description: "Relax App build with Vanilla Javascript",
  },
  {
    id: 12,
    title: "CASHFLOW CONTROLLER",
    screenshot: "/images/budgetcontroller.png",
    icons: "/images/basiciconsvite.png",
    languages: ["HTML5", "Sass", "Vite.js", "Javascript(ES6 Modules)"],
    mockups: "/mockups/incexpResp.png",
    screens: [
      { screenBig: "/screens/incexpBig.png" },
      { screenBig: "/screens/incexp1Big.png" },
      { screenBig: "/screens/incexp2Big.png" },
    ],
    github: "https://github.com/Noud63/cashflow-controller",
    github2: "https://finance-controller.netlify.app/",
    description: `Cashflow controller with Vite.js.`,
  },
  {
    id: 13,
    title: "GOALSETTER",
    screenshot: "/images/goalsetter.png",
    icons: "/images/allicons.png",
    languages: [
      "HTML5",
      "CSS3",
      "Javascript",
      "React Redux-Toolkit",
      "REST-api",
      "MongoDB",
    ],
    mockups: "/mockups/goalsetterResp.png",
    screens: [
      { screenBig: "/screens/goalsetterBig.png" },
      { screenBig: "/screens/goalsetter1Big.png" },
      { screenBig: "/screens/goalsetter2Big.png" },
    ],
    github: "https://github.com/Noud63/GoalSetter",
    github2: "",
    description: "GoalSetter is a full-stack MERN application.",
  },

  {
    id: 14,
    title: "ROLL THE DICE",
    screenshot: "/images/piggame.png",
    icons: "/images/basicicons.png",
    languages: ["HTML5", "CSS3", "Javascript"],
    mockups: "/mockups/piggameResp.png",
    screens: [
      { screenBig: "/screens/piggameBig.png" },
      { screenBig: "/screens/piggame1Big.png" },
      { screenBig: "/screens/piggame2Big.png" },
    ],
    github: "https://noud63.github.io/Pig-game/",
    github2: "https://noud63.github.io/Pig-game/",
    description: `Vanilla Javascript Pig Game Desktop App.`,
  },
  {
    id: 15,
    title: "NOUD VAN DUN",
    screenshot: "/images/noudvandun.png",
    icons: "/images/basicicons.png",
    languages: ["React", "Vite", "Tailwind"],
    mockups: "/mockups/noudvandunResp.png",
    screens: [
      { screenBig: "/screens/noudvandunBig.png" },
      { screenBig: "/screens/noudvandun1Big.png" },
      { screenBig: "/screens/noudvandun2Big.png" },
    ],
    github: "https://github.com/Noud63/noudvandun",
    github2: "https://www.noudvandun.nl",
    description: "My own personal Web App is all about contemporary art and more.\n Build with React/Vite and Tailwind",
  },
  {
    id: 16,
    title: "GOTHIC TAC TOE",
    screenshot: "/images/gothictactoe.png",
    icons: "/images/basicicons.png",
    languages: ["HTML5", "CSS3", "Javascript"],
    mockups: "/mockups/gothictactoeResp.png",
    screens: [
      { screenBig: "/screens/gothictactoeBig.png" },
      { screenBig: "/screens/gothictactoe1Big.png" },
      { screenBig: "/screens/gothictactoe2Big.png" },
    ],
    github: "https://github.com/Noud63/Gothic-Tac-Toe",
    github2: "https://gothic-tac-toe.netlify.app/",
    description: `Gothic-Tac-Toe desktop game built with Javascript.`,
  },
  {
    id: 17,
    title: "WEATHER FORECAST",
    screenshot: "/images/weatherapp.png",
    icons: "/images/basicresticons.png",
    languages: ["HTML5", "CSS3", "Javascript", "REST-api"],
    mockups: "/mockups/weatherappResp.png",
    screens: [
      { screenBig: "/screens/weatherappBig.png" },
      { screenBig: "/screens/weatherapp1Big.png" },
      { screenBig: "/screens/weatherapp2Big.png" },
    ],
    github: "https://github.com/Noud63/weather-app",
    github2: "https://noud63.github.io/weather-app/",
    description: `Weather app built with Javascript ES6 modules.`,
  },
  {
    id: 18,
    title: "PERSONAL DATABASE",
    screenshot: "/images/personaldatabase.png",
    icons: "/images/basicicons.png",
    languages: ["HTML5", "CSS3", "Javascript"],
    mockups: "/mockups/databaseResp.png",
    screens: [
      { screenBig: "/screens/databaseBig.png" },
      { screenBig: "/screens/database1Big.png" },
      { screenBig: "/screens/database2Big.png" },
    ],
    github: "https://github.com/Noud63/contactlist",
    github2: "",
    description: `Persons database desktop app.`,
  },
  {
    id: 19,
    title: "WHAT'S ON YOUR MIND",
    screenshot: "/images/whatsonyourmind.png",
    icons: "/images/basicicons.png",
    languages: ["HTML5", "CSS3", "Javascript"],
    mockups: "/mockups/messageboxResp.png",
    screens: [
      { screenBig: "/screens/messageboxBig.png" },
      { screenBig: "/screens/messagebox2Big.png" },
      { screenBig: "/screens/messagebox1Big.png" },
    ],
    github: "https://github.com/Noud63/MessageBox",
    github2: "https://whats-on-your-mind.netlify.app/",
    description: `Vanilla javascript Message Box`,
  },
  {
    id: 20,
    title: "REGISTRATION",
    screenshot: "/images/register.png",
    icons: "/images/basicicons.png",
    languages: ["HTML5", "CSS3", "Javascript"],
    mockups: "/mockups/registerformResp.png",
    screens: [
      { screenBig: "/screens/registerBig.png" },
      { screenBig: "/screens/register1Big.png" },
      { screenBig: "/screens/register2Big.png" },
    ],
    github: "https://github.com/Noud63/Register-form",
    github2: "https://signupandvalidate.netlify.app/",
    description: `Vanilla javascript registration form with validation.`,
  },
  {
    id: 21,
    title: "BUDGET CONTROLLER",
    screenshot: "/images/budgetapp.png",
    icons: "/images/basicicons.png",
    languages: ["HTML5", "CSS3", "Javascript"],
    mockups: "/mockups/budgetapp2Resp.png",
    screens: [
      { screenBig: "/screens/budgetappBig.png" },
      { screenBig: "/screens/budgetapp1Big.png" },
      { screenBig: "/screens/budgetapp2Big.png" },
    ],
    github: "https://github.com/Noud63/income-and-expenses",
    github2: "https://incomeandexpences.netlify.app/",
    description: `<p>Budgetapp in vanilla Javascript.</p>`,
  },
];
